import { colorPalette } from '../../ui-blocks/ColorPalette';

export const disabledStyles = {
	borderColor: 'colors.dark1',
	backgroundColor: 'colors.dark2',
};

export const expandedStyles = {
	padding: '4px 8px',
	'& .expanded-content': { maxWidth: '200px' },
};
export const expandOnHoverStyles = {
	'&:hover': {
		...expandedStyles,
	},
};

export const exportImageButtonsStyles = {
	exportImgButton: {
		flexGrow: 0,
		flexShrink: 0,

		width: 'fit-content',
		padding: '9px 8px',
		borderWidth: '1px',
		borderStyle: 'solid',

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		textTransform: 'none',
		transition: 'padding 0.5s ease-in-out',

		color: 'colors.light3',

		'&:hover': {
			backgroundColor: 'colors.dark4',
		},
		'&.Mui-disabled': disabledStyles,
		'& svg': {
			color: 'colors.light3',
			width: 'auto',
		},
	},

	regularExportImgButton: {
		minWidth: '32px',
		height: '32px',
		borderColor: 'colors.light5',
		borderRadius: '36px',
		backgroundColor: 'colors.dark6',
		'& svg': { height: '16px' },
	},

	upsizedExportImgButton: {
		minWidth: '48px',
		height: '48px',
		borderColor: 'colors.dark3',
		borderRadius: '24px',
		backgroundColor: 'colors.dark4',
		'& svg': { height: '24px' },
	},

	seedTextCont: {
		flexShrink: 0,
		maxWidth: 0,

		transition: 'max-width 0.5s ease-in-out',
		overflow: 'hidden',
	},
	seedText: {
		paddingLeft: '4px',

		gap: '8px',
		alignItems: 'center',

		'& svg': { height: ' 16px', width: 'auto' },
	},
	selectMedia: {
		display: 'flex',
		width: '24px',
		height: '24px',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '4px',
		border: `1px solid ${colorPalette.light5}`,
		backgroundColor: 'colors.dark6',
		'&:hover': {
			backgroundColor: 'colors.dark4',
		},
	},
};
